






































































import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class SjzxNavLeft extends Vue {
  @Prop()
  private cState;
  private get user() {
    return this.$store.state.user;
  }
}
